import { dashboard } from 'routes/routePaths';
import { Link as TileLink } from 'screens/Panel/screens/Dashboard/components/Dashboard/Dashboard';
import { isToggleOn } from 'utils/featureToggle';
import { FEATURE_TOGGLE } from 'utils/featureToggle/types';

/**
 * Determines whether to show the Case Management v3 tile
 * @returns the link information or not
 */
export const showNewCaseManTile = (): TileLink[] =>
  isToggleOn(FEATURE_TOGGLE.CASEMAN_V3)
    ? [{ label: 'Case Management v3', to: dashboard, toExternal: process.env.REACT_APP_CASE_MANAGEMENT_URL }]
    : [];
